import TotalApi from './TotalApi'
export default TotalApi;
